var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "Sao" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: { type: "text", disabled: true },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.sao.title"), active: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ValidityStartDate",
                            error: _vm.$v.form.ValidityStartDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.ValidityStartDate
                            },
                            model: {
                              value: _vm.form.ValidityStartDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ValidityStartDate", $$v)
                              },
                              expression: "form.ValidityStartDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ValidityEndDate",
                            error: _vm.$v.form.ValidityEndDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.ValidityEndDate
                            },
                            model: {
                              value: _vm.form.ValidityEndDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "ValidityEndDate", $$v)
                              },
                              expression: "form.ValidityEndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "StaffTypeId",
                            error: _vm.$v.form.StaffTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.StaffTypeId,
                              "lookup-key": "EMPLOYEE_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("StaffTypeId", $event)
                              }
                            },
                            model: {
                              value: _vm.staffType,
                              callback: function($$v) {
                                _vm.staffType = $$v
                              },
                              expression: "staffType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "BcpClusterCrteriaId",
                            error: _vm.$v.form.BcpClusterCrteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.BcpClusterCrteriaId,
                              "lookup-key": "CUSTOMER_DISCOUNT_GROUP_7"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "BcpClusterCrteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.bcpClusterCrteria,
                              callback: function($$v) {
                                _vm.bcpClusterCrteria = $$v
                              },
                              expression: "bcpClusterCrteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RegionCriteriaId",
                            error: _vm.$v.form.RegionCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RegionCriteriaId,
                              "lookup-key": "CUSTOMER_REGION_3"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "RegionCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.regionCriteria,
                              callback: function($$v) {
                                _vm.regionCriteria = $$v
                              },
                              expression: "regionCriteria"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.sao.details") } },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.soaDetailItems },
                    model: {
                      value: _vm.form.SaoDetails,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "SaoDetails", $$v)
                      },
                      expression: "form.SaoDetails"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9596fe4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9596fe4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Sao/update.vue
// module id = null
// module chunks = 